import * as localforage from "localforage";
const localforageFormCacheData = localforage.createInstance({
	driver      : localforage.INDEXEDDB,
	name        : 'Immo',
	version     : 1.0,
	size        : 4980736,
	storeName   : 'omnicasa-form-data',
	description : 'Omnicasa Web application Form edit caching data'
})
export class LocalforageWrapper{
	static getItem<T>(key: string, callback?: (err: any, value: T) => void): Promise<T> {
		return localforageFormCacheData.getItem(key, callback);
	}
	
	static setItem<T>(key: string, value: T, callback?: (err: any, value: T) => void): Promise<T> {
		return localforageFormCacheData.setItem(key, value, callback);
	}
	
	static removeItem(key: string, callback?: (err: any) => void): Promise<void> {
		return localforageFormCacheData.removeItem(key, callback);
	}
	
	static clear(callback?: (err: any) => void): Promise<void> {
		return localforageFormCacheData.clear(callback);
	}
	
	length(callback?: (err: any, numberOfKeys: number) => void): Promise<number> {
		return localforageFormCacheData.length(callback);
	}
	
	static key(keyIndex: number, callback?: (err: any, key: string) => void): Promise<string> {
		return localforageFormCacheData.key(keyIndex, callback);
	}
	
	static keys(callback?: (err: any, keys: string[]) => void): Promise<string[]> {
		return localforageFormCacheData.keys(callback);
	}
	
	static iterate<T, U>(iteratee: (value: T, key: string, iterationNumber: number) => U,
	              callback?: (err: any, result: U) => void): Promise<U> {
		return localforageFormCacheData.iterate(iteratee, callback);
	}
}